import React from 'react';
import { SnackbarProvider } from 'notistack';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const CustomSnackbarProvider = props => (
  <SnackbarProvider
    autoHideDuration={5000}
    maxSnack={5}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    preventDuplicate
    action={[
      <IconButton key="dismiss">
        <CloseIcon style={{ color: 'white' }} />
      </IconButton>
    ]}
  >
    {props.children}
  </SnackbarProvider>
);

export default CustomSnackbarProvider;
